const categoryMap = {
  MATERIAL: 'Materiaalilaskut',
  SUBCONTRACTORS: 'Aliurakointilaskut',
  WASTE: 'Jätelaskut',
  RENTAL: 'Vuokralaskut',
};

export const buildRuleDestinationString = (rule, projects, assignments) => {
  return [
    rule.destinationCompanyBid
      ? 'Y-tunnuksen korjaus: ' + rule.destinationCompanyBid
      : '',
    rule.destinationProject ? projects[rule.destinationProject]?.name : '',
    rule.destinationAssignment
      ? assignments[rule.destinationAssignment]?.name
      : '',
    rule.destinationCategory ? categoryMap[rule.destinationCategory] : '',
    typeof rule.destinationIlmoitettava === 'boolean'
      ? rule.destinationIlmoitettava
        ? 'Verottajailmoitettava'
        : 'Ei ilmoitettava'
      : '',
  ]
    .filter(Boolean)
    .join(', ');
};

export const groupRulesByDestination = (rules, projects, assignments) => {
  return rules.reduce((acc, rule) => {
    const ruleString = buildRuleDestinationString(rule, projects, assignments);

    if (!acc[ruleString]) {
      acc[ruleString] = [];
    }

    acc[ruleString].push(rule);
    return acc;
  }, {});
};
